module.exports = __webpack_public_path__ + "static/media/EUR.c2488419.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/currencies/EUR.svg
// module id = 2365
// module chunks = 7